export default "__VITE_ASSET__BAK_3LoQ__"